import { Row, Col, Modal, Skeleton, Badge, Table, Button } from "antd";
import React, { useState, useEffect } from "react";
import useRequest from "../../../hooks/useRequest";
import { ShowToast, Severty } from "../../../helper/toast";

export const ViewDealer = ({ path, show, hide, data }) => {

  const { request } = useRequest()
  const [loading, setLoading] = useState(false)
  const [list, setList] = useState([])

  const fetchData = () => {
    request({
      url: path + "?productId=" + data._id,
      method: 'GET',
      onSuccess: (data) => {
        setLoading(false);
        setList(data.data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR)
      }
    })
  }

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (_, { user_id }) => {
        return user_id && user_id.name ? <span className="cap">{user_id.name}</span> : '-';
      },
    },
    {
      title: "Email Address",
      dataIndex: "email",
      key: "email",
      render: (_, { user_id }) => {
        return user_id && user_id.email ? <a target="_blank" href={`/user/dealer/view/${user_id._id}`}>{user_id.email}</a> : '-';
      },
    },
    {},
  ];

  useEffect(() => {
    setLoading(true)
    fetchData(data._id);
  }, [])

  return (
    <Modal open={show} width={800} title='Provider (Whos Having This Product)' footer={[<Button onClick={() => hide()}>Ok</Button>]} onCancel={hide}>
      {loading ? [1, 2].map(item => <Skeleton active key={item} />) :
        <Col span={12} xs={24} md={24}>
          <div className="table-responsive customPagination">
            <Table
              loading={loading}
              columns={columns}
              dataSource={list}
              pagination={true}
              className="ant-border-space"
            />
          </div>
        </Col>
      }
    </Modal>
  )
}


